import styled from 'styled-components';
import IconChevronDownCircle from './IconChevronDownCircle';
var IconChevronLeftCircle = /*#__PURE__*/styled(IconChevronDownCircle).withConfig({
  displayName: "IconChevronLeftCircle",
  componentId: "c11n-8-111-1__sc-b0cs55-0"
})(["transform:rotate(90deg);"]);
export default IconChevronLeftCircle;